// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__C3jZB","topBottomGutter":"Layout_topBottomGutter__1OkVP"};